import React from 'react';

const TextField = (props) => {
    let value = (props.value !== "") ? props.value : "未回答";

    if (props.type === 'birthday' && value !== "未回答") {
        value = value.slice(0,4) + "年" + value.slice(4,6) + "月" + value.slice(6,8) + "日"
    }

    return (
        <p>{value}</p>
    );
};

export default TextField;